import fp from 'lodash/fp';


export const floatValueHelpers = {
    parse: value => fp.pipe(
        fp.replace(/ /g, ''),
        fp.replace(/(,)/, '.'),
        fp.replace(/[^\d.]+/g, ''),
        fp.replace(/(^\d{0,}\.?\d{0,2})(.*)/g, '$1'),
    )(value?.toString() || ''),
    format: value => value?.toString()
        .replace(/^(0|\s)+((?=[0-9]+[,.])|(?=[1-9]+))/g, '')
        .replace(/(\d)(?=(\d{3})+(\.|$))/g, '$1 ') || '',
    onKeyPress: e => {
        const value = e.target.value?.replace(/ /g, '') || '';
        if (!/[0-9,.]/.test(e.key) || /[,.]/.test(e.key) && /\d*\./.test(value))
            e.preventDefault();
    },
};

export const floatWithNegativeValueHelpers = {
    parse: value => fp.pipe(
        fp.replace(/ /g, ''),
        fp.replace(/(,)/, '.'),
        fp.replace(/[^\d.-]+/g, ''),
        fp.replace(/([.-]){1,}/g, '$1'),
        fp.replace(/(^-?\d{0,}\.?\d{0,2})(.*)/g, '$1'),
    )(value?.toString() || ''),
    format: value =>
        value?.toString()
            .replace(/^(0|\s)+((?=[0-9]+[,.])|(?=[1-9]+))/g, '')
            .replace(/(-?\d)(?=(\d{3})+(\.|$))/g, '$1 ') || '',
    onKeyPress: e => {
        const value = e.target.value?.replace(/ /g, '') || '';
        if (!/[0-9,.-]/.test(e.key) || /[,.]/.test(e.key) && /\d*\./.test(value) ||
            /[-]/.test(e.key) && /\d{1,}\.?/.test(value))
            e.preventDefault();
    },
};

export const intValuesHelpers = {
    parse: value => fp.pipe(
        fp.replace(/ /g, ''),
        fp.replace(/(^\d+)(\.*\d*)/g, '$1'),
        fp.replace(/[^\d]+/g, ''),
    )(value?.toString() || ''),
    format: value => value?.toString()
        .replace(/^(0|\s)+/g, '')
        .replace(/(\d)(?=(\d{3})+($))/g, '$1 ') || '',
    onKeyPress: e => {
        if (!/[0-9]/.test(e.key))
            e.preventDefault();
    },
};
